import { cn } from "../utils";

function Skeleton({ className, ...props }: React.ComponentProps<"div">) {
  return <div className={cn("animate-pulse rounded-md bg-border", className)} {...props} />;
}

export { Skeleton };
